import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useIsMobile } from "src/hooks/useIsMobile";
import { FaqsProps } from "../../FrequentlyAskedQuestions";

interface Props {
  section: string;
  f: FaqsProps;
  handleSetSearchParam: (p: string) => void;
}

const Header = ({ f, section, handleSetSearchParam }: Props) => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const param = t(f.param);
  const isSelected = section === param;

  return (
    <Box
      padding="8px 16px"
      display="flex"
      alignItems="center"
      alignSelf="stretch"
      justifyContent="center"
      sx={{
        border: "1px solid #DCE4E8",
        borderRadius: "100px",
        cursor: "pointer",
        backgroundColor: isSelected ? "#00b6b9" : "transparent",
      }}
      onClick={() => handleSetSearchParam(param)}
    >
      <Typography
        variant={isMobile ? "body2" : "body1"}
        color={isSelected ? "#ffffff" : "#000000"}
        textAlign="center"
      >
        {t(f.section)}
      </Typography>
    </Box>
  );
};

export default Header;
